export class UiTabs {
    constructor(tabs = []) {
        this.tabs = tabs
        this.tab = tabs[0];
    }

    select(tab) {
        this.tab = tab;
    }

    isSelected(tab) {
        return this.tab == tab;
    }

}